import { render, staticRenderFns } from "./OpenCodelabAction.vue?vue&type=template&id=12d9147f&"
import script from "./OpenCodelabAction.vue?vue&type=script&lang=js&"
export * from "./OpenCodelabAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports